import { z } from 'zod';

import type { Side } from '../../utils';
import { SIDES, responsiveSchema } from '../../utils';

/** Four sides and one unit — a padding or a margin. */
export const spacingSchema = z.object({
    value: z.object({
        top: z.coerce.number().default(0),
        right: z.coerce.number().default(0),
        bottom: z.coerce.number().default(0),
        left: z.coerce.number().default(0),
    }),
    unit: z.enum(['px', '%']).default('px'),
});

/**
 * Both spellings are exported because not every setting is per-breakpoint: a row
 * carries one padding for every screen, while a block carries three.
 */
export const responsiveSpacingSchema = responsiveSchema(spacingSchema);

export type Spacing = z.output<typeof spacingSchema>;
export type SpacingSides = Spacing['value'];

/** Every side the same, `0px` by default. */
export const createSpacing = (value = 0, unit: Spacing['unit'] = 'px'): Spacing => ({
    value: Object.fromEntries(SIDES.map((side: Side) => [side, value])) as SpacingSides,
    unit,
});
